import { getBackRoyalApiBaseConfig } from 'BackRoyalApi';
import { createApi } from 'ReduxHelpers';
import {
    type DocumentCollection,
    type UpdateStudentRecordsParams,
    type UserForStudentRecords,
} from '../AdminStudentRecordsTab.types';
import { USER_STUDENT_RECORDS_FIELDS } from '../constants';

type UsersResponse = { contents: { users: UserForStudentRecords[] } };

export const adminStudentRecordsApi = createApi('adminStudentRecordsApi', {
    ...getBackRoyalApiBaseConfig('adminStudentRecordsApi'),
    endpoints: builder => ({
        getUserForStudentRecords: builder.query<UserForStudentRecords, string>({
            query: userId => ({
                url: `users/${userId}`,
                params: { 'fields[]': USER_STUDENT_RECORDS_FIELDS },
            }),
            transformResponse: (response: UsersResponse) => response.contents.users?.[0],
        }),

        // users_controller#update is a collection route; the id travels in `record`.
        updateStudentRecords: builder.mutation<void, UpdateStudentRecordsParams>({
            query: ({ record, meta }) => ({ method: 'put', url: 'users.json', body: { record, meta } }),
        }),

        deleteDocument: builder.mutation<void, { collection: DocumentCollection; id: string }>({
            query: ({ collection, id }) => ({ method: 'delete', url: `${collection}/${id}` }),
        }),
    }),
});

export default adminStudentRecordsApi;
